import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { Link2 } from "lucide-react";
import { useDatasetExplorerStore } from "../datasetExplorerStore";

/**
 * Checkbox list for toggling available joins on the selected dataset.
 * Enabling a join makes its fields available in the FieldPicker.
 */
export default function JoinPicker() {
  const schemas = useDatasetExplorerStore((s) => s.schemas);
  const selectedDataset = useDatasetExplorerStore((s) => s.selectedDataset);
  const enabledJoins = useDatasetExplorerStore((s) => s.enabledJoins);
  const toggleJoin = useDatasetExplorerStore((s) => s.toggleJoin);

  const currentSchema = schemas.find((s) => s.dataset === selectedDataset);
  if (!currentSchema || currentSchema.joins.length === 0) {
    return null;
  }

  return (
    <div className="space-y-2">
      <Label className="text-xs font-medium text-muted-foreground uppercase tracking-wider flex items-center gap-1.5">
        <Link2 className="h-3 w-3" />
        Joins
      </Label>
      <div className="space-y-1.5">
        {currentSchema.joins.map((join) => (
          <div
            key={join.prefix}
            className={`flex items-start gap-2 rounded-md px-2 py-1.5 transition-colors ${
              enabledJoins.has(join.prefix)
                ? "bg-primary/5 hover:bg-primary/8"
                : "hover:bg-muted/50"
            }`}
          >
            <Checkbox
              id={`join-${join.prefix}`}
              checked={enabledJoins.has(join.prefix)}
              onCheckedChange={() => toggleJoin(join.prefix)}
              className="mt-0.5"
            />
            <label
              htmlFor={`join-${join.prefix}`}
              className="text-sm leading-tight cursor-pointer"
            >
              <span className="font-medium">{join.prefix}</span>
              <span className="text-muted-foreground text-xs block mt-0.5">
                {join.description}
              </span>
            </label>
          </div>
        ))}
      </div>
    </div>
  );
}
